import { formatTimeString, getRepeatEndDate } from 'tsx/libs/dayjs';

import { faEdit } from '~components/icon';
import { buildColumn, EditableColumnConfig } from '~components/table-view';

const columnsList: EditableColumnConfig[] = [
  {
    id: 'client.full_name',
    header: 'Client',
    type: 'link',
    props: {
      meta: {
        link: ({ id }: any) => `/appointments/${id}`,
        hoverIcon: faEdit,
      },
    },
  },
  {
    id: 'user.full_name',
    header: 'Care Worker',
    type: 'text',
  },
  {
    id: 'client.referrer_name',
    header: 'Referrer',
    type: 'text',
  },
  {
    id: 'client.region.name',
    header: 'Client Region',
    type: 'text',
  },
  {
    id: 'repeat_start',
    header: 'Repeat Start',
    type: 'date',
  },
  {
    id: 'repeat_end',
    header: 'Repeat End',
    type: 'date',
    accessorFn: ({ repeat_end }) => getRepeatEndDate(repeat_end),
  },
  {
    id: 'start_time',
    header: 'Start Time',
    type: 'text',
    accessorFn: ({ start_time }) => formatTimeString(start_time),
  },
  {
    id: 'end_time',
    header: 'End Time',
    type: 'text',
    accessorFn: ({ end_time }) => formatTimeString(end_time),
  },
  {
    id: 'repeat_frequency.day',
    header: 'Week Day',
    type: 'text',
  },
  {
    id: 'repeat_frequency.frequency',
    header: 'Week Repeat Count',
    type: 'text',
  },
  {
    id: 'status.name',
    header: 'Status',
    type: 'text',
  },
  {
    id: 'service_type.name',
    header: 'Service Type',
    type: 'text',
    accessorFn: ({ service_type }) =>
      service_type !== undefined ? `${service_type.name}${service_type.deleted ? ' - DELETED' : ''}` : '',
  },
  {
    id: 'package_fixed.name',
    header: 'Package',
    type: 'text',
  },
];

export const columns = columnsList.map(buildColumn);

export default columns;
